import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { Shutter } from '../model/shutter';


@Component({
  selector: 'app-shutter',
  templateUrl: './shutter.component.html',
  styleUrls: ['./shutter.component.css'],    
  animations: [
    trigger('shutterState', [
      state('up', style({
        top: '-200px'
      })),
      state('down', style({
        top: '0px'
      })),
      transition ('up => down', animate('10000ms ease-out')),
      transition ('down => up', animate('10000ms ease-in'))
    ]),
    trigger('slitStatus', [
      state('open', style({borderStyle: 'solid', borderWidth: '1px'})),
      state('close', style({borderStyle: 'none', borderWidth: '0px'})),
      transition('open <=> close', animate('100ms ease-out'))
    ]),
    trigger('blinds',[
      transition(':enter', [
          style({height:0}), 
          animate('1000ms ease-in', 
            style({height:'*'}))
          ]),
      transition(':leave', [
        style({height:'*'}), 
        animate('1000ms ease-in', 
          style({height:0}))
        ])
    ]),
    trigger('slits', [])
  ]
})


export class ShutterComponent implements OnInit {

  @Input() shutter:Shutter;
  @Output() stopped = new EventEmitter();

  protected error:number = 0.2;

  protected t0_100:number = 50000; //In ms. Time need the shutter to go down
  protected t100_0:number = 60000; //In ms. Time need the shutter to go up without tslits
  protected t0_50:number = 20000; //In ms. Time need the shutter to put from 0 to 50
  protected t50_0:number = 25000; //In ms. Time need the shutter
  protected t50_100:number = 30000;
  protected t100_50:number = 35000;//in ms. Time to needs go up without tslits.
  protected tSlits:number = 10000; //time for close/open slits. lineal ecuation
  protected _position:number = 0;
  protected _positionSlit:number = 0;
  protected _positionWithError:number = 0; //The real position with error, could be > 100
  protected lastPosition:number = 0;
  protected lastPositionSlit:number = 0;  

  //Inputs from the actuator
  protected tMove:number = this.t100_0 + this.tSlits;
  protected dir:string = "0"; //0 up 1 down  

  //Coeficientes de la ecuación
  protected aD:number = 0;
  protected bD:number = 0;
  protected aU:number = 0;
  protected bU:number = 0;

  //Animations vars
  protected nBlinds:number = 20;
  protected idIntervalSlit;
  protected tFrameSlit:number = 10;
  protected slit:number = 0;
  protected totalTimeSlits = 0;
  public currentBlind:number = 0;  
  protected currentSlit:number = 0;  

  protected intervalBlinds:any;
  protected intervalSlits:any;
  protected timeout:any;

  protected _tIntervalBlinds:number = 500;
  protected _tIntervalSlits:number = 200;


  protected stylesBlind:Array<string> = new Array(10);

  protected maxPosBlinds:number = 100;
  protected maxPosSlits:number = 0;

  protected readonly percentBlindDefault:number = 100;
  protected readonly percentBlindNoSlitCorr:number = 90;
  protected readonly percentSlitDefault:number = 0;
  protected readonly percentSlitNoSlitCorr:number = 10;


  constructor() { }

  ngOnInit() {
    this.calculateCoeficientes(); 
    for (let i = 0; i < this.nBlinds; i++) {
      this.stylesBlind[i] = 'dashed';
    } 

    /*this.maxPosBlinds = this.shutter.slitCorrection?this.percentBlindDefault:this.percentBlindNoSlitCorr;
    this.maxPosSlits = this.shutter.slitCorrection?this.percentSlitDefault:this.percentSlitNoSlitCorr;*/
    
  }

  move(pos){
    /*let _positions = this.calculatePosition();
    this.lastPosition = this.position;
    this.lastPositionSlit = this._positionSlit;
    this._position = positions.position;
    this._positionSlit = positions._positionSlit;*/
    let posPedida = +pos, slitPos = this.nBlinds, posWithError;
    if (pos) {
      //Calculate error position
      let error = 0;
      if (!this.shutter.timeDiffCorrection)
        error += 0.1;
      if (!this.shutter.curveCorrection)
        error += 0.2;
      if (!this.shutter.slitCorrection)
        error += 0.3;
      pos = +pos + pos*error;
      posWithError = +pos;
      pos = pos > 100 ? 100 : pos;
      //this.dir = this._position - pos === 0 ? (this.dir === "0"?"1":"0") : (this._position - pos > 0 ? "0" : "1");
      //I use the positionWithError for calculate the direction, then I always know the real direction
      /*this.dir = this._positionWithError - +posWithError > 0 ? "0" : "1"; 
      this._positionWithError = posWithError;*/

      this.dir = this._position - pos > 0 ? "0" : "1";
            
      //this._position = pos;
      //If calculate position is higher than 95 if like 100 because the blind size is 5%
      if (pos > 95 && posPedida !== 100) {
          if (!this.shutter.timeDiffCorrection)
            error += 10;
          if (!this.shutter.curveCorrection)
            error += 10;
          if (!this.shutter.slitCorrection)
            error += 30;
        slitPos = Math.round(error * this.nBlinds / 100);
      }
      else if (this.dir==="0") {
        slitPos = 0;
      }      
    }
    else {
      pos = this._position > 0 ? 0 : 100;
      posPedida = pos;
    }
    
    clearInterval(this.intervalBlinds);
    clearInterval(this.intervalSlits); 
    clearTimeout(this.timeout);
    
    let blindPos = Math.round(pos * this.nBlinds / 100);
    /*this.maxPosBlinds = this.shutter.slitCorrection?this.percentBlindDefault:this.percentBlindNoSlitCorr;
    this.maxPosSlits = this.shutter.slitCorrection?this.percentSlitDefault:this.percentSlitNoSlitCorr;*/

    if (this.dir === "1") {           
      this.intervalBlinds = setInterval(()=>{
        this.currentBlind = this.currentBlind < blindPos?this.currentBlind+1:this.currentBlind;        
        this._position = this.currentBlind * this.maxPosBlinds / this.nBlinds;
        if (this.currentBlind >= blindPos) {          
          clearInterval(this.intervalBlinds);   
          //Is in the botton close slits
          if (this.currentBlind >= this.nBlinds) {
            this.timeout = setTimeout(()=>{             
              this.intervalSlits = setInterval(()=>{
                this._positionSlit = this.currentSlit * 100 / this.nBlinds;
                if (!this.shutter.slitCorrection) {
                  this._position += this.maxPosSlits / this.nBlinds;
                  this._position = this._position > 100 ?  100 : this._position;
                }
                this.stylesBlind[this.nBlinds - this.currentSlit] = 'none';
                if (this.currentSlit >= slitPos){
                  if (!this.shutter.slitCorrection) {
                    this._position += this.maxPosSlits / this.nBlinds;
                    this._position = this._position > 100 ?  100 : this._position;
                  }
                  clearInterval(this.intervalSlits);
                  this.stopped.emit();
                } 
                else{                   
                  this.currentSlit++;
                } 
              },this._tIntervalSlits);                   
            },this._tIntervalBlinds);         
          }
          else{
            this.stopped.emit();
          }      
        }
      },this._tIntervalBlinds);        
    }
    else {        
      //Open the slits
      this.intervalSlits = setInterval(()=>{
        if (this.currentBlind === this.nBlinds && this.currentSlit > slitPos){
          this._positionSlit = this.currentSlit * 100 / this.nBlinds;
          if (!this.shutter.slitCorrection) {
            this._position -= this.maxPosSlits / this.nBlinds; 
          }
          this.stylesBlind[this.nBlinds - this.currentSlit] = 'dashed';
          this.currentSlit--;
        } 
        else {          
          clearInterval(this.intervalSlits);
          if (this.currentSlit === 0) {   
            this._positionSlit = 0;         
            this.intervalBlinds = setInterval(()=>{
              this._position = this.currentBlind * this.maxPosBlinds / this.nBlinds;
              if (this.currentBlind === blindPos){
                clearInterval(this.intervalBlinds);
                this.stopped.emit();
              } 
              else { 
                this.currentBlind = this.currentBlind > 0?this.currentBlind-1:this.currentBlind;            
              } 
            },this._tIntervalBlinds);
          }
          else {
            this.stopped.emit();
          }
        } 
      }, this._tIntervalSlits);   
      
    }
  } 


  moveSlits(pos){
    //If the shutter has slitCorrection
    if (this.shutter.slitCorrection) {          
      pos = +pos;
      let nSlit = this.nBlinds - 1;
      clearInterval(this.intervalBlinds);
      clearInterval(this.intervalSlits); 
      clearTimeout(this.timeout);
      
      let slitPos = Math.round(+pos * this.nBlinds / 100);

      this.dir === "1";
      
      this.intervalBlinds = setInterval(()=>{
        this.currentBlind = this.currentBlind < this.nBlinds?this.currentBlind+1:this.currentBlind;        
        this._position =this.currentBlind * 100 / this.nBlinds;
        if (this.currentBlind >= this.nBlinds) {          
          clearInterval(this.intervalBlinds);                       
            this.timeout = setTimeout(()=>{                            
              if(+pos - this._positionSlit > 0) {                
                this.intervalSlits = setInterval(()=>{
                  this._positionSlit = this.currentSlit * 100 / this.nBlinds;
                  this.stylesBlind[this.nBlinds - this.currentSlit] = 'none';
                  if (this.currentSlit >= slitPos){
                    clearInterval(this.intervalSlits);
                    this.stopped.emit();
                  } 
                  else{                   
                    this.currentSlit++;
                  }               
                },this._tIntervalSlits);                   
              }
              else {
                this.intervalSlits = setInterval(()=>{
                  this._positionSlit = this.currentSlit * 100 / this.nBlinds;
                  this.stylesBlind[this.nBlinds - this.currentSlit] = 'dashed';
                  if (this.currentSlit <= slitPos){
                    clearInterval(this.intervalSlits);
                    this.stopped.emit();
                  } 
                  else{                   
                    this.currentSlit--;
                  }               
                },this._tIntervalSlits);
              }
            },this._tIntervalBlinds);                   
        }
      },this._tIntervalBlinds);        
    }
  } 

  /***********************************
   * GETTERS & SETTERS
   ***********************************/
  get position() {
    return this._position;
  }

  get positionSlit() {
    return this._positionSlit;
  }
  /***********************************
   * GETTERS & SETTERS
   ***********************************/


  private calculatePosition():any{
    let result =  {position:0, positionSlit:0}, tPrev = 0, tPos = 0;

    if (this.dir === "0"){ //Subir
      let tMoveAux = this.tMove;
      if (this._positionSlit > 0) {
        //we have to move the slits first
        tPrev = (this._positionSlit * this.tSlits) / 100;
        tPos = tMoveAux - tPrev;

        if (tPos <= 0) { 
          tPos = tPrev - tMoveAux;         
          result.positionSlit = Math.round((tPos * 100) / this.tSlits);
          tMoveAux = 0;
        }
        else {
          result.positionSlit = 0;          
          tMoveAux = tPos;
        }
      }
      // calcule time 100% to previous position
      tPrev = this.aU * this.position * this.position + this.bU * this.position + this.t100_0;	  		
      
      // calcule time(in seconds) 100% to actual position
      tPos = (tPrev + tMoveAux);
      if(this.aU !== 0){// si es una funcion cuadrada resolvemos con la función
        // Calcule actual position ( Solve ecuation : cx2 + dx - (e-time) = 0 ) === NEGATIVE SOLUTION
        result.position = (- this.bU - (Math.sqrt(this.bU*this.bU - 4*this.aU*(this.t100_0-tPos))))/(2*this.aU);
      }
      else{
        result.position = (tPos - this.t100_0) / this.bU;
      }
    } 
    else{ //Bajar
      tPrev = this.aD*this.position*this.position + this.bD*this.position;
      tPos = this.tMove + tPrev;
  
      if (this.aD !== 0){
        result.position = (-this.bD + Math.sqrt(this.bD*this.bD+4*this.aD*tPos)) / (2*this.aD);
      } 
      else{
        result.position = tPos / this.bD;      
      } 
    } 

    result.position = Math.round(result.position);    

    if (result.position < 0) {
      result.position = 0;
    }
    else if (result.position > 100) {
        result.position = 100;
        if (this._positionSlit < 100) {
          let tOver = tPos - this.t0_100;
          if (tOver >= this.tSlits) {
            result.positionSlit = 100;
          }
          else {
            result.positionSlit = Math.round((tOver * 100) / this.tSlits);
          }
        }
        else {
          result.positionSlit = this._positionSlit;
        }
    }
    

    return result;
  }


/**
 * Calcula los coeficientes fijos a y b para la ecuación de segundo grado por el 
 * método de Gauss-Jordan
 */
  private calculateCoeficientes():void{
    
    let matriz = new Array<Array<number>>();

    //init array
    for (let i = 0; i < 2; i++){ 
      matriz[i] = new Array<number>();
    } 

    //Ecuación bajada
    //50*50*a + 50*b = 20000
    matriz[0][0] = 50*50;
    matriz[0][1] = 50;
    matriz[0][2] = this.t0_50;

    //100*100*a + 100*b = 50000
    matriz[1][0] = 100*100;
    matriz[1][1] = 100;
    matriz[1][2] = this.t0_100;

    //Gauss-Jordan 
    matriz[0][1]=matriz[0][1]/matriz[0][0];
    matriz[0][2]=matriz[0][2]/matriz[0][0];
    matriz[0][0]=matriz[0][0]/matriz[0][0];

    matriz[1][1]=((-matriz[1][0])*matriz[0][1])+matriz[1][1];
		matriz[1][2]=((-matriz[1][0])*matriz[0][2])+matriz[1][2];
		matriz[1][0]=((-matriz[1][0])*matriz[0][0])+matriz[1][0];


    matriz[1][2]=matriz[1][2]/matriz[1][1];//y solution
    matriz[1][1]=matriz[1][1]/matriz[1][1];
    matriz[0][2]=((-matriz[0][1])*matriz[1][2])+matriz[0][2];//x solution
    matriz[0][1]=((-matriz[0][1])*matriz[1][1])+matriz[0][1];

    this.aD = matriz[0][2];
    this.bD = matriz[1][2];

    //Calculo ecuación 
    	// Ecuación subida y = (aU*x*x +  bU*x + tSlits)	( y = tiempo; x = posicion; )			
			
      //  50*50*c +  50*d = 12.3 -21.05
      
			matriz[0][0] = 50*50;
			matriz[0][1]	= 50;
			matriz[0][2] = this.t100_50 - this.t100_0;
			// 100*100*c + 100*d = 0 - 21.05	  
			matriz[1][0] = 100*100;
			matriz[1][1]	= 100;
			matriz[1][2] = - this.t100_0;
		   //Resolviendo sistema con base en metodo de Gauss-Jordan 
		   matriz[0][1]=matriz[0][1]/matriz[0][0];
		   matriz[0][2]=matriz[0][2]/matriz[0][0];
		   matriz[0][0]=matriz[0][0]/matriz[0][0];// Se hace 1
		   //----------------------------------------------
		   matriz[1][1]=((-matriz[1][0])*matriz[0][1])+matriz[1][1];
		   matriz[1][2]=((-matriz[1][0])*matriz[0][2])+matriz[1][2];
		   matriz[1][0]=((-matriz[1][0])*matriz[0][0])+matriz[1][0];// Se hace 0
		   //-------------------------------------------------------------------
		   matriz[1][2]=matriz[1][2]/matriz[1][1];//Solucion variable y
		   matriz[1][1]=matriz[1][1]/matriz[1][1];
		   //----------------------------------------------
		   matriz[0][2]=((-matriz[0][1])*matriz[1][2])+matriz[0][2];//Solucion variable x
		   matriz[0][1]=((-matriz[0][1])*matriz[1][1])+matriz[0][1];
		   //-------------------------------------------------------------------
		   this.aU = matriz[0][2];
		   this.bU = matriz[1][2];
  } 

  
  private animationStarted(event):void{
    console.log("animation started");
  } 

  private animationDone(event):void{
    console.log("animation done");
  } 

}
